


























































































import {Component, Prop} from "vue-property-decorator"
import AbpBase from "../../lib/abpbase"
import {CreateHealthPropadanda,HealthPropadandaInfo} from "../../api/healthPropaganda"
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

@Component({
    components: {quillEditor}
})
export default class AddOrEdit extends AbpBase{
    @Prop({required: true, default: false}) value:boolean
    @Prop() data:any
    @Prop() title:any
    
    //富文本配置项
    editorOption = {
        action:XMLHTTP_BASEURL+'/api/services/app/HealthPropaganda/FileSave',
        methods: 'POST',  // 必填参数 图片上传方式
        token: '',  // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        name: 'img',  // 必填参数 文件的参数名
        size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon'  // 可选 可上传的图片格式
    }
    form:any = {
        id:0,
        content:'',
        tenantId:0,
        resourceTitle:'',
        titlePinyin:'',
        resourceType:'图片',
        coverPath:'',
        categoryList:[],
        fileList:'',
    }
    //封面路径暂存
    imageUrl = ''
    //上传地址
    url = XMLHTTP_BASEURL
    async created() {
        await this.getSelects()
        if(this.data){
            let res = await HealthPropadandaInfo({id:this.data.id})
            this.form = Object.assign({},res.data)
            this.form.id = this.data.id
            this.imageUrl = this.url+res.data.coverPath
            this.form.categoryList = res.data.categoryList.map((item:any)=>{
                return item.id
            })
            
            this.fileList = res.data.fileList.map((item:any)=>{
                return {name:'',url:this.url+item.path,oldUrl:item.path}
            })
            if(res.data.resourceType == '视频'){
                this.videoForm.Video = this.url+res.data.fileList[0].path
            }
        }
    }
    //切换格式，清掉图文
    typeChange(){
        this.videoForm.Video = ''
        this.form.fileList = []
        this.fileList = []
        this.form.content = ''
    }
    async getPY(){
        let obj = await this.GetPinYinAndWubi({inputStr:this.form.resourceTitle})
        let val = eval('(' + obj + ')')
        this.form.titlePinyin = val.PinYin
    }
    //宣教分类
    categoryList:any = []
    async getSelects(){
        this.categoryList = (await this.QuerySysDic({dataType:7,typeName:'',status:true})).data
    }
    async save() {
        (this.$refs['modelForm'] as any).validate(async (valid) => {
            if (valid) {
                if(this.form.coverPath==''){
                    this.$message.warning('请上传封面')
                    return false
                }
                if(this.fileList.length==0 && this.form.resourceType!='文本'){
                    if(this.form.resourceType=='视频'){
                        this.$message.warning('请上传视频')
                    }else if(this.form.resourceType=='图片'){
                        this.$message.warning('请上传至少一张图片')
                    }
                    return false
                }
                this.form.categoryList = this.form.categoryList.map((item:any)=>{
                    return {id:item}
                })
                this.form.fileList = this.fileList.map((item:any)=>{
                    return {path:item.response?item.response.result[0].imgUrl:item.oldUrl?item.oldUrl:item.url}
                })
                let res = await CreateHealthPropadanda(this.form)
                if (res.code === 2000) {
                    this.$emit('save-success')
                    this.$emit('input', false)
                }
            } else {
                return false;
            }
        });
    }
    cancel() {
        this.$emit('input', false)
    }
    modelRule = {
        resourceTitle:{required: true,message:'不能为空',trigger: 'blur'},
        // titlePinyin:{required: true,message:'不能为空',trigger: 'blur'},
        categoryList:{required: true,message:'至少选择一项',type:'array',trigger: 'change'},
    }
    //封面上传回调
    handleAvatarSuccess(res, file) {
        this.form.coverPath = res.result[0].imgUrl
        this.imageUrl = URL.createObjectURL(file.raw);
    }
    beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 10MB!');
        }
    }
    dialogImageUrl = ''
    dialogVisible = false
    disabled = false
    fileList = []
    //图片文件
    handleRemove(file,fileList) {
        this.fileList = fileList
    }
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    }
    handlePicSuccess(res,file,fileList){
        this.fileList = fileList
    }
    videoForm:any = {
        Video:'',
    }
    videoFlag = false
    videoUploadPercent = 0
    //视频文件
    beforeUploadVideo(file) {
        const isLt500M = file.size / 1024 / 1024  < 500;
        if (['video/mp4', 'video/ogg', 'video/flv','video/avi','video/wmv','video/rmvb'].indexOf(file.type) == -1) {
            this.$message.error('请上传正确的视频格式');
            return false;
        }
        if (!isLt500M) {
            this.$message.error('上传视频大小不能超过500MB哦!');
            return false;
        }
    }
    uploadVideoProcess(event, file, fileList){
        this.videoFlag = true;
        this.videoUploadPercent = Number(file.percentage.toFixed(0));
    }
    handleVideoSuccess(res, file,fileList) {            
        this.videoFlag = false;
        this.videoUploadPercent = 0;
        if(res.success){
            this.videoForm.Video = this.url+res.result[0].imgUrl;
            this.fileList = fileList
        }else{
            this.$message.error('视频上传失败，请重新上传！');
        }
    }


}
